export const siteSettings = {
  name: "Elite Markets",
  link: "https://elitemarkets.net",
  email: "support@elitemarkets.net",
  appLink: "https://app.elitemarkets.net",
};
